document.addEventListener('alpine:init', () => {
  const RECENT_KEY = 'faf:recent-searches:v1';

  Alpine.data('fafSearchPage', () => ({
    filtersOpen: false,
    filterTrigger: null,
    loadingMore: false,
    sectionId: '',
    nextUrl: '',
    searchSuggestions: null,
    suggestionsInitPromise: null,
    suggestionsDestroyed: false,
    suggestions: [],
    suggestionsOpen: false,
    suggestionIndex: -1,
    suggestionTerm: '',

    init() {
      this.sectionId = this.$root.dataset.sectionId || '';

      const loadMore = this.$root.querySelector(
        '[data-search-load-more]'
      );

      this.nextUrl = loadMore?.dataset.nextUrl || '';

      this.renderRecentSearches();
        this.saveSearch(this.currentQuery());

      this.ensureSuggestions();
    },

    currentQuery() {
      return String(
        this.$root.querySelector('[data-search-form] input[name="q"]')
          ?.value || ''
      ).trim();
    },

    ensureSuggestions() {
      if (this.suggestionsDestroyed || !this.$root.isConnected) return Promise.resolve(false);
      if (this.searchSuggestions?.helpers) return Promise.resolve(true);
      if (this.suggestionsInitPromise) return this.suggestionsInitPromise;
      if (typeof window.onTagalysReady !== 'function') return Promise.resolve(false);

      this.suggestionsInitPromise = Promise.resolve()
        .then(() => window.onTagalysReady(() => {
          if (!this.suggestionsDestroyed && this.$root.isConnected) this.startSuggestions();
        }))
        .then((ready) => Boolean(ready && this.searchSuggestions?.helpers))
        .catch(() => false)
        .finally(() => { this.suggestionsInitPromise = null; });
      return this.suggestionsInitPromise;
    },

    startSuggestions() {
      if (this.suggestionsDestroyed || !this.$root.isConnected || this.searchSuggestions) return;
      if (typeof window.Tagalys?.APIConnector?.SearchSuggestions?.new !== 'function') return;
        if (
            !window.Tagalys
            ?.APIConnector
            ?.SearchSuggestions
        ) {
            return;
        }

        this.searchSuggestions =
            Tagalys.APIConnector
            .SearchSuggestions
            .new({
                params: {
                request: {
                    searches: {
                    limit: 6,
                    },
                },
                },

                onSuccess: (response) => {
                if (this.suggestionsDestroyed || !this.$root.isConnected) return;
                const currentTerm =
                    String(
                    this.$refs
                        .searchInput
                        ?.value || ''
                    ).trim();

                const items =
                    response?.queries?.find(
                    (query) =>
                        query.section_id ===
                        'searches'
                    )?.items || [];

                this.suggestions =
                    items
                    .filter((item) => {
                        const label =
                        String(
                            item
                            ?.displayString ||
                            ''
                        ).trim();

                        return (
                        label &&
                        label.toLowerCase() !==
                            currentTerm
                            .toLowerCase()
                        );
                    })
                    .slice(0, 6);

                this.suggestionIndex = -1;

                this.suggestionsOpen =
                    document.activeElement ===
                    this.$refs.searchInput &&
                    currentTerm.length >= 2 &&
                    this.suggestions.length > 0;
                },

                onFailure: () => {
                if (this.suggestionsDestroyed || !this.$root.isConnected) return;
                this.suggestions = [];
                this.suggestionsOpen = false;
                this.suggestionIndex = -1;
                },
            });

        if (
            document.activeElement ===
            this.$refs.searchInput
        ) {
            this.requestSuggestions(
            this.$refs.searchInput.value
            );
        }
        },
    requestSuggestions(value) {
      const term = String(value || '').trim();
      this.suggestionTerm = term;
      if (this.suggestionsDestroyed || !this.$root.isConnected) return;

      if (term.length < 2 || !this.searchSuggestions?.helpers) {
        this.suggestions = [];
        this.suggestionsOpen = false;
        this.suggestionIndex = -1;
        if (term.length >= 2) this.ensureSuggestions();
        return;
      }
      this.searchSuggestions.helpers.updateQuery(term);
    },


        closeSuggestions() {
        this.suggestionsOpen = false;
        this.suggestionIndex = -1;
        },

        applySuggestion(value) {
        const term =
            String(value || '').trim();

        if (
            !term ||
            !this.$refs.searchInput
        ) {
            return;
        }

        this.$refs.searchInput.value =
            term;

        this.saveSearch(term);

        this.closeSuggestions();

        this.$refs.searchInput
            .form
            ?.requestSubmit();
        },

        handleSuggestionKeydown(event) {
        if (event.key === 'Escape') {
            this.closeSuggestions();
            return;
        }

        if (
            !this.suggestionsOpen ||
            !this.suggestions.length
        ) {
            return;
        }

        if (event.key === 'ArrowDown') {
            event.preventDefault();

            this.suggestionIndex =
            (
                this.suggestionIndex + 1
            ) %
            this.suggestions.length;

            return;
        }

        if (event.key === 'ArrowUp') {
            event.preventDefault();

            this.suggestionIndex =
            this.suggestionIndex <= 0
                ? this.suggestions.length - 1
                : this.suggestionIndex - 1;

            return;
        }

        if (
            event.key === 'Enter' &&
            this.suggestionIndex >= 0
        ) {
            event.preventDefault();

            this.applySuggestion(
            this.suggestions[
                this.suggestionIndex
            ]?.displayString
            );
        }
        },

    readRecentSearches() {
      try {
        const value = JSON.parse(
          window.localStorage.getItem(RECENT_KEY) || '[]'
        );

        return Array.isArray(value)
          ? value.slice(0, 6)
          : [];
      } catch (_) {
        return [];
      }
    },

    saveSearch(query) {
      query = String(query || '').trim();

      if (query.length < 2) return;

      const existing = this.readRecentSearches().filter(
        (item) =>
          String(item).toLowerCase() !== query.toLowerCase()
      );

      try {
        window.localStorage.setItem(
          RECENT_KEY,
          JSON.stringify([query, ...existing].slice(0, 6))
        );
      } catch (_) {
        // Recent searches are optional.
      }
    },

    renderRecentSearches() {
      const holder = this.$root.querySelector(
        '[data-recent-searches]'
      );

      if (!holder) return;

      holder.innerHTML = '';

      this.readRecentSearches().forEach((query) => {
        const link = document.createElement('a');

        link.href =
        `${window.routes.search}?q=${encodeURIComponent(query)}` +
        '&type=product' +
        '&options%5Bprefix%5D=last';

        link.className =
          'body-x-small text-sg-navy underline underline-offset-4';

        link.textContent = query;

        holder.appendChild(link);
      });

      holder.classList.toggle(
        'hidden',
        holder.children.length === 0
      );
    },

    openFilters(event) {
      this.filterTrigger =
        event?.currentTarget || document.activeElement;

      this.filtersOpen = true;

      window.FAFScrollLock?.lock?.(
        'search-filters-v2'
      );

      this.$nextTick(() => {
        requestAnimationFrame(() => {
          (
            this.$refs.filterClose ||
            this.$refs.filterPanel
          )?.focus({
            preventScroll: true,
          });
        });
      });
    },

    closeFilters() {
      if (!this.filtersOpen) return;

      this.filtersOpen = false;

      window.FAFScrollLock?.unlock?.(
        'search-filters-v2'
      );

      const trigger = this.filterTrigger;

      this.filterTrigger = null;

      this.$nextTick(() => {
        trigger?.focus?.({
          preventScroll: true,
        });
      });
    },

    trapFocus(event) {
      if (
        !this.filtersOpen ||
        event.key !== 'Tab' ||
        !this.$refs.filterPanel
      ) {
        return;
      }

      const focusable = Array.from(
        this.$refs.filterPanel.querySelectorAll(
          [
            'a[href]',
            'button:not([disabled])',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            '[tabindex]:not([tabindex="-1"])',
          ].join(',')
        )
      ).filter(
        (element) => element.offsetParent !== null
      );

      if (!focusable.length) {
        event.preventDefault();
        this.$refs.filterPanel.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (
        event.shiftKey &&
        document.activeElement === first
      ) {
        event.preventDefault();
        last.focus();
      } else if (
        !event.shiftKey &&
        document.activeElement === last
      ) {
        event.preventDefault();
        first.focus();
      }
    },

    async loadMore(button) {
    if (
        this.loadingMore ||
        !this.nextUrl ||
        !this.sectionId
    ) {
        return;
    }

    this.loadingMore = true;

    try {
        const url = new URL(
        this.nextUrl,
        window.location.origin
        );

        url.searchParams.set(
        'section_id',
        this.sectionId
        );

        const response = await fetch(url, {
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        });

        if (!response.ok) {
        throw new Error(
            `Search pagination failed: ${response.status}`
        );
        }

        const html = await response.text();

        const documentFragment = new DOMParser()
        .parseFromString(html, 'text/html');

        const incomingGrid =
        documentFragment.querySelector(
            '[data-search-results-grid]'
        );

        const targetGrid =
        this.$root.querySelector(
            '[data-search-results-grid]'
        );

        if (!incomingGrid || !targetGrid) {
        throw new Error(
            'Search results grid not found'
        );
        }

        const existingCardCount =
        targetGrid.querySelectorAll(
            '[data-elevar-product-card]'
        ).length;

        const appendedCards = [];

        Array.from(incomingGrid.children).forEach(
        (item) => {
            const card = item.querySelector(
            '[data-elevar-product-card]'
            );

            targetGrid.appendChild(item);

            if (card) {
            appendedCards.push(card);
            }
        }
        );

        window.FAFSections?.enhance?.(
        targetGrid,
        {
            source: 'search-load-more',
        }
        );

        window.FAFAnalytics?.viewItemListCards?.(
        appendedCards,
        {
            list: 'search_results',
            startPosition: existingCardCount,
        }
        );

        const incomingLoadMore =
        documentFragment.querySelector(
            '[data-search-load-more]'
        );

        this.nextUrl =
        incomingLoadMore?.dataset.nextUrl || '';

        if (button) {
        button.dataset.nextUrl = this.nextUrl;

        if (!this.nextUrl) {
            button.remove();
        }
        }

        window.dispatchEvent(
        new CustomEvent(
            'faf:search:append',
            {
            detail: {
                count: appendedCards.length,
                nextUrl: this.nextUrl,
            },
            }
        )
        );
    } catch (error) {
        console.error(error);

        /*
        * Progressive fallback:
        * if AJAX loading fails, use normal
        * Shopify pagination.
        */
        if (this.nextUrl) {
        window.location.href = this.nextUrl;
        }
    } finally {
        this.loadingMore = false;
    }
    },

    destroy() {
      this.suggestionsDestroyed = true;
      this.suggestions = [];
      this.suggestionsOpen = false;
      window.FAFScrollLock?.unlock?.(
        'search-filters-v2'
      );
    },
  }));
});